import { Action, AnyAction } from '../action.type';
import { AppState } from '../app.state';
import {
  RetrieveSeasonFightsPayload,
  RetrieveSeasonFightsSuccessPayload,
  RETRIEVE_SEASON_FIGHTS,
  RETRIEVE_SEASON_FIGHTS_FAILURE,
  RETRIEVE_SEASON_FIGHTS_SUCCESS,
} from './seasonFights.action.type';

export const seasonFightsReducers = (
  state: AppState,
  action: AnyAction,
): AppState => {
  switch (action.type) {
    case RETRIEVE_SEASON_FIGHTS:
      return retrieveSeasonFightsReducer(state, action);
    case RETRIEVE_SEASON_FIGHTS_SUCCESS:
      return retrieveSeasonFightsSuccessReducer(state, action);
    case RETRIEVE_SEASON_FIGHTS_FAILURE:
      return retrieveSeasonFightsFailureReducer(state, action);
    default:
      return state;
  }
};

const retrieveSeasonFightsReducer = (
  state: AppState,
  _action: Action<RetrieveSeasonFightsPayload>,
): AppState => {
  return {
    ...state,
    seasonFights: {
      ...state.seasonFights,
      isLoading: true,
    },
  };
};

export const retrieveSeasonFightsSuccessReducer = (
  state: AppState,
  action: Action<RetrieveSeasonFightsSuccessPayload>,
): AppState => {
  const newFights = action.payload.fights;
  const currentFights = state.seasonFights.seasonFights;

  if (
    currentFights.length !== newFights.length ||
    !currentFights.every(
      (fight, index) => fight.fight_id === newFights[index].fight_id,
    )
  ) {
    return {
      ...state,
      seasonFights: {
        ...state.seasonFights,
        seasonFights: newFights,
        selectedSeasonId: action.payload.seasonId,
        lastUpdated: action.payload.lastUpdated,
        isLoading: false,
      },
    };
  }
  return {
    ...state,
    seasonFights: {
      ...state.seasonFights,
      selectedSeasonId: action.payload.seasonId,
      lastUpdated: action.payload.lastUpdated,
      isLoading: false,
    },
  };
};

export const retrieveSeasonFightsFailureReducer = (
  state: AppState,
  action: Action<string>,
): AppState => {
  console.log('Error retrieving Season Fights: none found!');
  return {
    ...state,
    seasonFights: {
      ...state.seasonFights,
      error: action.payload,
      isLoading: false,
    },
  };
};
